module.exports = __webpack_public_path__ + "img/otro.237e50d5.png";